import { render, staticRenderFns } from "./KullaniciDegerlendirilecekFormListesi.vue?vue&type=template&id=38c7c522"
import script from "./KullaniciDegerlendirilecekFormListesi.vue?vue&type=script&lang=js"
export * from "./KullaniciDegerlendirilecekFormListesi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports